<template>
  <b-col class="">
    <b-row v-if="checkEmpty">
      <b-col cols="12">
        <headerPdf title="سوابق تکمیلی" />
      </b-col>
      <b-col v-if="renderedItem.biography" cols="12" class="my-2">
        <div class="blockquote-footer my-2">
          زندگی نامه، مهمترین افتخارات و ارزش‌ها
        </div>
        <div class="ml-4 f-s-b-12 line-h text-justify">
          {{ renderedItem.biography }}
        </div>
      </b-col>
      <b-col v-if="renderedItem.favorites" cols="12" class="my-2">
        <div class="blockquote-footer my-2">
          مهارت، علاقه مندی یا فعالیت خاصی
        </div>
        <div class="ml-4 f-s-b-12 line-h text-justify">
          {{ renderedItem.favorites }}
        </div>
      </b-col>
      <b-col v-if="renderedItem.finalIntroduction" cols="12" class="my-2">
        <div class="blockquote-footer my-2">توضیحات مهم</div>
        <div class="ml-4 f-s-b-12 line-h text-justify">
          {{ renderedItem.finalIntroduction }}
        </div>
      </b-col>
      <b-col v-if="renderedItem.convictionHistory" cols="12" class="my-2">
        <div class="blockquote-footer my-2">پرونده قضایی</div>
        <div class="ml-4 f-s-b-12 line-h text-justify">
          {{ renderedItem.convictionHistory }}
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import headerPdf from "../headerPdf.vue";
import { pathOr } from "ramda";

export default {
  name: "Complete",
  components: {
    headerPdf,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    renderedItem() {
      return {
        biography: pathOr("", ["biography"], this.item),
        favorites: pathOr("", ["favorites"], this.item),
        finalIntroduction: pathOr("", ["final_introduction"], this.item),
        convictionHistory: pathOr("", ["conviction_history"], this.item),
      };
    },
    checkEmpty() {
      return Object.values(this.item).some((item) => item);
    },
  },
  methods: { pathOr },
};
</script>

<style lang="scss" scoped>
.information-pro {
  font-size: 14px;
  font-weight: 500;
  color: #282c52;
}

.line-h {
  line-height: 22.5px;
}
</style>
